<template>
  <div class="relative">
    <RevButtonIcon
      :aria-label="i18n(translations.cartIconAltText)"
      :icon="IconShoppingBag"
      :title="i18n(translations.cartIconAltText)"
      :to="resolveLocalizedRoute({ name: CHECKOUT.CART })"
      variant="secondary"
      @click="
        trackClick({
          zone: 'header',
          name: 'cart',
        })
      "
    />
    <span
      v-if="user.cartItemsCount > 0"
      class="bg-action-danger-hi text-onaction-default-hi rounded-full label-small-bold pointer-events-none absolute right-3 top-3 box-content flex h-16 w-16 items-center justify-center border-1"
      >{{ user.cartItemsCount }}</span
    >
  </div>
</template>

<script setup lang="ts">
import { useNuxtApp, useRouteLocationWithLocale } from '#imports'
import { onMounted } from 'vue'

import { useUserStore } from '@backmarket/nuxt-layer-oauth/useUserStore'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevButtonIcon } from '@ds/components/ButtonIcon'
import { IconShoppingBag } from '@ds/icons/IconShoppingBag'

import { CHECKOUT } from '~/scopes/checkout/routes-names'

import translations from './CartIcon.translations'

const { user, fetchUser } = useUserStore()

const i18n = useI18n()

const { trackClick } = useTracking()
const resolveLocalizedRoute = useRouteLocationWithLocale()

// TODO: [CK-3730] Remove this fetch and let the cart page update the cartItemsCount directly (as done in pastrami)
// The user is already fetched in the user plugin on the first load
// We don't need to fetch it again.
// However, we can refresh the user data on next client-side navigation
// (e.g after the user navigates back from the cart page to the home page)
const nuxtApp = useNuxtApp()
if (!nuxtApp.isHydrating) {
  onMounted(async () => {
    await fetchUser()
  })
}
</script>
